import { render, staticRenderFns } from "./ZoneArea.vue?vue&type=template&id=252f8369&"
import script from "./ZoneArea.vue?vue&type=script&lang=js&"
export * from "./ZoneArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports